import { ExceptionEvent } from "@fairfleet/geotab";

export enum WarningType {
  TT_RED = "redTellTale",
  TT_YELLOW = "yellowTellTale",
  PM = "predictiveMaintenance",
  PM1 = "predictiveMaintenance1",
  AD = "accident",
  SB = "seatbelt",
}

export default interface Warning {
  type: WarningType;
  event?: ExceptionEvent;
}
